import React, { useState, useEffect } from "react";
import { getMetadata, updateMetadata } from '../../services/MetadataService';

import trg10  from '../../assets/sound/trg-10p.mp3';
import trg15  from '../../assets/sound/trg-15p.mp3';
import trg20  from '../../assets/sound/trg-20p.mp3';
import trg25  from '../../assets/sound/trg-25p.mp3';
import trg30  from '../../assets/sound/trg-30p.mp3';
import trg35  from '../../assets/sound/trg-35p.mp3';
import trg40  from '../../assets/sound/trg-40p.mp3';
import trg45  from '../../assets/sound/trg-45p.mp3';
import trg50  from '../../assets/sound/trg-50p.mp3';
import trg55  from '../../assets/sound/trg-55p.mp3';
import trg60  from '../../assets/sound/trg-60p.mp3';
import trg65  from '../../assets/sound/trg-65p.mp3';
import trg70  from '../../assets/sound/trg-70p.mp3';
import trg75  from '../../assets/sound/trg-75p.mp3';
import trg80  from '../../assets/sound/trg-80p.mp3';
import trg85  from '../../assets/sound/trg-85p.mp3';
import trg90  from '../../assets/sound/trg-90p.mp3';
import trg95  from '../../assets/sound/trg-95p.mp3';
import trg100 from '../../assets/sound/trg-15p.mp3';
const AudioPlayer = () => {
    // State to track if audio is playing
    const [isPlaying, setIsPlaying] = useState(false);
    const [value, setValue] = useState('');

    var Played10  = "Played10";
    var Played15  = "Played15";
    var Played20  = "Played20";
    var Played25  = "Played25";
    var Played30  = "Played30";
    var Played35  = "Played35";
    var Played40  = "Played40";
    var Played45  = "Played45";
    var Played50  = "Played50";
    var Played55  = "Played55";
    var Played60  = "Played60";
    var Played65  = "Played65";
    var Played70  = "Played70";
    var Played75  = "Played75";
    var Played80  = "Played80";
    var Played85  = "Played85";
    var Played90  = "Played90";
    var Played95  = "Played95";
    var Played100 = "Played100";

    var trangeplaysound = "trange.play.sound";
    var string          = "String";
        
    useEffect(() => {
            const interval = setInterval(() => { listMetadata(); }, 5000)
            return () => {  clearInterval(interval); }
    });

    function listMetadata() {
        getMetadata(trangeplaysound).then((response) => {
            // console.log(response.data.value);
            setValue(response.data.value);
            choosePlaySound(value);
        }).catch(error => {
            console.log(error);
        })
    }
    function saveOrUpdateMetadata(name, datatype, value) {
        const metadata = { name, datatype, value }
        updateMetadata(name, metadata).then((response) => {
            // console.log(response.data)
        }).catch(error => {
            console.log(error);
        })
    }
    // Play Audio
    const togglePlay = (audio, played) => {
        // play 01 sound each 05 secs
        saveOrUpdateMetadata(trangeplaysound, string, played);
        if (isPlaying) {
            // console.log("wait 05 secs starts");
            setTimeout(() => { console.log("05 secs passed."); }, 5000); // 5000 milliseconds = 5 seconds
        }
        setIsPlaying(true);
        audio.play();
        // console.log("wait 05 secs starts");
        setTimeout(() => { console.log("05 secs passed."); }, 5000); // 5000 milliseconds = 5 seconds
        setIsPlaying(false);
    };
    function choosePlaySound(level) {
        switch (level) {
            case "Play10" : togglePlay(new Audio(trg10) , Played10) ; break;
            case "Play15" : togglePlay(new Audio(trg15) , Played15) ; break;
            case "Play20" : togglePlay(new Audio(trg20) , Played20) ; break;
            case "Play25" : togglePlay(new Audio(trg25) , Played25) ; break;
            case "Play30" : togglePlay(new Audio(trg30) , Played30) ; break;
            case "Play35" : togglePlay(new Audio(trg35) , Played35) ; break;
            case "Play40" : togglePlay(new Audio(trg40) , Played40) ; break;
            case "Play45" : togglePlay(new Audio(trg45) , Played45) ; break;
            case "Play50" : togglePlay(new Audio(trg50) , Played50) ; break;
            case "Play55" : togglePlay(new Audio(trg55) , Played55) ; break;
            case "Play60" : togglePlay(new Audio(trg60) , Played60) ; break;
            case "Play65" : togglePlay(new Audio(trg65) , Played65) ; break;
            case "Play70" : togglePlay(new Audio(trg70) , Played70) ; break;
            case "Play75" : togglePlay(new Audio(trg75) , Played75) ; break;
            case "Play80" : togglePlay(new Audio(trg80) , Played80) ; break;
            case "Play85" : togglePlay(new Audio(trg85) , Played85) ; break;
            case "Play90" : togglePlay(new Audio(trg90) , Played90) ; break;
            case "Play95" : togglePlay(new Audio(trg95) , Played95) ; break;
            case "Play100": togglePlay(new Audio(trg100), Played100); break;
            default       : break;                     
        }
    }
    return (<></>);
};

export default AudioPlayer;